var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 72,
    viewBox: "0 0 78 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.3262,
    cy: 38.7003,
    r: 32.3262,
    fill: "white",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.6527,
    cy: 30.0496,
    r: 12.7484,
    fill: "#FFBC00"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.10621,
    cy: 60.0994,
    r: 4.55299,
    fill: "#3C37FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0322 39.8544C29.4308 37.3108 30.327 33.3961 30.327 29.0055C30.327 28.5998 30.3195 28.1986 30.3045 27.8019H34.3501C34.3355 28.1986 34.328 28.5998 34.3276 29.0055C34.3276 33.3961 35.2238 37.3108 36.6224 39.8544H28.0322Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3295 29.0055C34.3295 28.5998 34.337 28.1986 34.352 27.8019H30.3064C30.321 28.1986 30.3285 28.5998 30.3288 29.0055C30.3288 29.7882 30.2996 30.5558 30.2451 31.3031C30.2451 31.3031 32.1926 30.1113 34.4154 31.3031C34.3581 30.5558 34.3295 29.7882 34.3295 29.0055Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3134 27.8019H30.7318C30.7434 28.1986 30.7494 28.5998 30.7498 29.0055C30.7498 33.3961 30.0429 37.3108 28.9399 39.8544H30.1761C30.8768 37.3108 31.3263 33.3961 31.3263 29.0055C31.3255 28.5998 31.3212 28.1986 31.3134 27.8019Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6243 39.8544H34.4807C33.78 37.3108 33.3311 33.3961 33.3311 29.0055C33.3311 28.5998 33.3348 28.1986 33.3423 27.8019H34.3537C34.3391 28.1986 34.3316 28.5998 34.3312 29.0055C34.3295 33.3961 35.2257 37.3108 36.6243 39.8544Z",
    fill: "#F8B805"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7657 25.3855H26.7606C23.6006 25.3731 21.1704 25.132 19.1128 24.6263C16.6467 24.0201 14.6862 23.0188 13.1191 21.5646C9.75961 18.4478 8.19531 13.2155 8.19531 5.09795C8.19515 4.9234 8.23034 4.75063 8.29877 4.59006C8.36721 4.42948 8.46746 4.28444 8.59348 4.16367C8.7195 4.0429 8.86867 3.94891 9.03201 3.88737C9.19535 3.82583 9.36946 3.79802 9.54384 3.8056C9.6433 3.8101 19.5539 4.24444 26.7056 3.91798C26.88 3.91039 27.0541 3.93821 27.2174 3.99975C27.3807 4.06129 27.5299 4.15528 27.6559 4.27605C27.782 4.39682 27.8822 4.54186 27.9506 4.70243C28.0191 4.86301 28.0543 5.03578 28.0541 5.21032V24.0931C28.0541 24.4359 27.9179 24.7646 27.6756 25.0069C27.4332 25.2493 27.1045 25.3855 26.7618 25.3855H26.7657ZM10.7946 6.44254C10.9474 13.0166 12.2555 17.2381 14.8767 19.6699C17.0428 21.6798 20.2517 22.6316 25.4728 22.7805V6.55267C20.0332 6.72854 13.5636 6.54143 10.7946 6.44254Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9703 5.25079C11.8141 5.24518 11.6583 5.27189 11.5129 5.32926C11.3674 5.38663 11.2354 5.47342 11.125 5.5842C11.0147 5.69497 10.9284 5.82734 10.8716 5.97301C10.8147 6.11869 10.7886 6.27452 10.7948 6.43076V6.44312C13.5863 6.54201 20.0609 6.728 25.473 6.5555V5.32159C20.6998 5.47555 15.1326 5.35025 11.9703 5.25079Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4736 22.7796V22.465C25.5 22.6243 25.5017 22.7325 25.4736 22.7796Z",
    fill: "#F8B805"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7948 6.43011L10.824 6.44304H10.7948C10.9476 13.0171 12.2557 17.2386 14.8769 19.6704C17.043 21.6803 20.2519 22.6321 25.473 22.781C25.1077 23.3991 23.0237 23.085 23.0237 23.085C8.90908 22.9086 10.7948 6.43011 10.7948 6.43011Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0236 24.2947V5.41135C28.0237 5.2368 27.9885 5.06403 27.9201 4.90346C27.8517 4.74289 27.7514 4.59784 27.6254 4.47707C27.4994 4.3563 27.3502 4.26231 27.1869 4.20077C27.0235 4.13923 26.8494 4.11142 26.675 4.11901C19.5239 4.44659 9.61332 4.01225 9.51386 4.00663C9.21715 3.9934 8.92495 4.08278 8.6864 4.25972C8.44786 4.43665 8.27754 4.69036 8.2041 4.97813C8.2344 4.64731 8.39093 4.34086 8.6412 4.1224C8.89147 3.90394 9.21625 3.79024 9.54814 3.80491C9.64759 3.80941 19.5582 4.24375 26.7099 3.91729C26.8842 3.9097 27.0584 3.93751 27.2217 3.99905C27.385 4.06059 27.5342 4.15458 27.6602 4.27535C27.7863 4.39612 27.8865 4.54117 27.9549 4.70174C28.0234 4.86231 28.0586 5.03508 28.0584 5.20963V24.093C28.0582 24.2006 28.0448 24.3078 28.0185 24.4121C28.0219 24.3734 28.0236 24.334 28.0236 24.2947Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4536 24.8853C25.5036 24.8932 26.5524 24.9593 27.5951 25.0831C27.3627 25.2781 27.0691 25.3851 26.7657 25.3854H26.7607C23.6006 25.373 21.1704 25.132 19.1128 24.6263C16.6467 24.02 14.6863 23.0187 13.1192 21.5646C11.356 19.9284 10.085 17.7095 9.27979 14.7966C10.7059 19.1175 14.4778 24.769 24.4536 24.8853Z",
    fill: "#F8B805"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9785 25.0085C36.858 24.8884 36.7624 24.7458 36.6971 24.5887C36.6318 24.4316 36.5982 24.2632 36.5981 24.0931V5.20922C36.598 5.03468 36.6332 4.86191 36.7016 4.70134C36.77 4.54076 36.8703 4.39572 36.9963 4.27495C37.1223 4.15418 37.2715 4.06019 37.4348 3.99865C37.5982 3.93711 37.7723 3.90929 37.9467 3.91688C45.0984 4.24446 55.009 3.81012 55.1084 3.80451C55.2828 3.79692 55.4569 3.82473 55.6202 3.88627C55.7836 3.94781 55.9328 4.0418 56.0588 4.16257C56.1848 4.28334 56.285 4.42839 56.3535 4.58896C56.4219 4.74953 56.4571 4.9223 56.4569 5.09685C56.4569 13.2144 54.8926 18.4467 51.5331 21.5635C49.966 23.0177 48.0056 24.019 45.5395 24.6252C43.4818 25.1309 41.0517 25.372 37.8916 25.3844H37.8866C37.5462 25.3835 37.2199 25.2484 36.9785 25.0085ZM39.1828 6.5527V22.7806C44.4039 22.6317 47.6111 21.6798 49.7795 19.67C52.4001 17.2381 53.7082 13.0166 53.861 6.44257C51.092 6.54146 44.6202 6.72857 39.1817 6.5527H39.1828Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1816 5.32151V6.55261C44.5937 6.72736 51.0684 6.54137 53.8598 6.44023V6.42787C53.866 6.27168 53.8399 6.11589 53.7832 5.97026C53.7264 5.82463 53.6401 5.69229 53.5298 5.58152C53.4196 5.47076 53.2876 5.38395 53.1422 5.32655C52.9968 5.26914 52.8411 5.24237 52.6849 5.24791C49.5226 5.35017 43.9554 5.47547 39.1816 5.32151Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1818 22.7796V22.465C39.1555 22.6243 39.1543 22.7325 39.1818 22.7796Z",
    fill: "#F8B805"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8604 6.43011L53.8312 6.44304H53.8598C53.707 13.0171 52.3989 17.2386 49.7783 19.6704C47.6116 21.6803 44.4027 22.6321 39.1816 22.781C39.5469 23.3991 41.6309 23.085 41.6309 23.085C55.7455 22.9086 53.8604 6.43011 53.8604 6.43011Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.632 24.2947V5.41135C36.6318 5.2368 36.667 5.06403 36.7355 4.90346C36.8039 4.74289 36.9041 4.59784 37.0302 4.47707C37.1562 4.3563 37.3054 4.26231 37.4687 4.20077C37.632 4.13923 37.8062 4.11142 37.9805 4.11901C45.1317 4.44659 55.0428 4.01225 55.1417 4.00663C55.4384 3.9934 55.7306 4.08278 55.9692 4.25972C56.2077 4.43665 56.378 4.69036 56.4515 4.97813C56.4212 4.64731 56.2646 4.34086 56.0144 4.1224C55.7641 3.90394 55.4393 3.79024 55.1074 3.80491C55.008 3.80941 45.0974 4.24375 37.9457 3.91729C37.7713 3.9097 37.5972 3.93751 37.4339 3.99905C37.2705 4.06059 37.1213 4.15458 36.9953 4.27535C36.8693 4.39612 36.7691 4.54117 36.7006 4.70174C36.6322 4.86231 36.597 5.03508 36.5972 5.20963V24.093C36.5973 24.2006 36.6109 24.3079 36.6376 24.4121C36.6338 24.3731 36.6319 24.3339 36.632 24.2947Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2016 24.8854C39.1516 24.8926 38.1028 24.9579 37.0601 25.081C37.2925 25.2759 37.586 25.383 37.8894 25.3833H37.8945C41.0545 25.3709 43.4847 25.1299 45.5423 24.6242C48.0084 24.0179 49.9689 23.0166 51.536 21.5624C53.2992 19.9262 54.5702 17.7073 55.3753 14.7945C53.9476 19.1177 50.1773 24.7691 40.2016 24.8854Z",
    fill: "#F8B805"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6906 0C17.3278 2.09693 17.1466 4.22125 17.1489 6.34933C17.1489 19.5464 23.941 30.2447 32.3199 30.2447C40.6988 30.2447 47.4909 19.5464 47.4909 6.34933C47.4933 4.22125 47.312 2.09693 46.9492 0H17.6906Z",
    fill: "#F8B805"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6906 0C17.3278 2.09693 17.1466 4.22125 17.1489 6.34933C17.1489 19.5464 23.941 30.2447 32.3199 30.2447C40.6988 30.2447 47.4909 19.5464 47.4909 6.34933C47.4933 4.22125 47.312 2.09693 46.9492 0H17.6906Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9494 0H41.4806C41.7079 2.10877 41.8205 4.22834 41.8177 6.34933C41.8177 19.5464 37.5648 30.2447 32.3179 30.2447C40.6967 30.2447 47.4888 19.5464 47.4888 6.34933C47.492 4.22131 47.3115 2.09699 46.9494 0Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5337 7.83087L34.5217 11.859L38.9673 12.5052L35.7505 15.6411L36.5102 20.0688L32.5337 17.978L28.5572 20.0688L29.3169 15.6411L26.1001 12.5052L30.5458 11.859L32.5337 7.83087Z",
    fill: "#F7A108"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8197 6.3511C22.8169 4.23011 22.9294 2.11054 23.1568 0.00177002H19.4191C19.0983 2.10295 18.9385 4.22557 18.9409 6.3511C18.9426 19.5476 24.9312 30.2465 32.3206 30.2465C27.0737 30.2465 22.8197 19.5476 22.8197 6.3511Z",
    fill: "#F8B805"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2791 7.32136C23.0405 7.32136 24.4684 5.89347 24.4684 4.13208C24.4684 2.3707 23.0405 0.94281 21.2791 0.94281C19.5177 0.94281 18.0898 2.3707 18.0898 4.13208C18.0898 5.89347 19.5177 7.32136 21.2791 7.32136Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4683 8.5855C25.1666 8.5855 25.7326 8.01948 25.7326 7.32125C25.7326 6.62303 25.1666 6.05701 24.4683 6.05701C23.7701 6.05701 23.2041 6.62303 23.2041 7.32125C23.2041 8.01948 23.7701 8.5855 24.4683 8.5855Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1106 0.471424C40.0736 0.471424 46.5292 0.260154 46.5292 0H17.6914C17.6914 0.260154 24.1469 0.471424 32.1106 0.471424Z",
    fill: "#F8B805"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4563 39.8545H26.1998C25.815 39.8544 25.4339 39.9302 25.0783 40.0774C24.7227 40.2246 24.3996 40.4404 24.1275 40.7125C23.8553 40.9846 23.6394 41.3077 23.4921 41.6633C23.3449 42.0188 23.269 42.3999 23.269 42.7847H41.3865C41.3865 42.3999 41.3108 42.0189 41.1635 41.6634C41.0162 41.3079 40.8004 40.9848 40.5283 40.7127C40.2562 40.4406 39.9332 40.2248 39.5777 40.0775C39.2221 39.9303 38.8411 39.8545 38.4563 39.8545Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1998 40.0742H38.4563C39.1954 40.0741 39.9073 40.3534 40.4491 40.8561C40.991 41.3588 41.3228 42.0477 41.3781 42.7847H41.3871C41.3871 42.0076 41.0784 41.2623 40.5289 40.7127C39.9793 40.1632 39.234 39.8545 38.4569 39.8545H26.1998C25.815 39.8544 25.4339 39.9302 25.0783 40.0774C24.7227 40.2246 24.3996 40.4404 24.1275 40.7125C23.8553 40.9846 23.6394 41.3077 23.4921 41.6633C23.3449 42.0188 23.269 42.3999 23.269 42.7847H23.278C23.3334 42.0477 23.6653 41.3589 24.2072 40.8562C24.749 40.3536 25.4608 40.0742 26.1998 40.0742Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3862 42.7847H38.1087C38.1087 41.1665 37.2715 39.8545 36.2388 39.8545H38.456C39.2331 39.8545 39.9784 40.1632 40.528 40.7127C41.0775 41.2623 41.3862 42.0076 41.3862 42.7847Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8181 39.8545H27.402C27.0171 39.8544 26.636 39.9302 26.2805 40.0774C25.9249 40.2246 25.6018 40.4404 25.3296 40.7125C25.0575 40.9846 24.8416 41.3077 24.6943 41.6633C24.547 42.0188 24.4712 42.3999 24.4712 42.7847H26.8907C26.8907 42.0081 27.199 41.2632 27.7479 40.7137C28.2969 40.1643 29.0414 39.8552 29.8181 39.8545Z",
    fill: "#F8B805"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1196 42.7849H18.5365C18.3866 42.7849 18.2651 42.9064 18.2651 43.0562V53.7709C18.2651 53.9208 18.3866 54.0423 18.5365 54.0423H46.1196C46.2695 54.0423 46.391 53.9208 46.391 53.7709V43.0562C46.391 42.9064 46.2695 42.7849 46.1196 42.7849Z",
    fill: "#44352A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1196 52.1071H18.5365C18.4646 52.1071 18.3955 52.0785 18.3446 52.0276C18.2937 51.9767 18.2651 51.9077 18.2651 51.8357V53.7708C18.2651 53.8428 18.2937 53.9118 18.3446 53.9627C18.3955 54.0136 18.4646 54.0422 18.5365 54.0422H46.1196C46.1552 54.0422 46.1905 54.0352 46.2234 54.0216C46.2563 54.0079 46.2861 53.9879 46.3113 53.9627C46.3364 53.9375 46.3564 53.9076 46.37 53.8746C46.3835 53.8417 46.3905 53.8064 46.3904 53.7708V51.8357C46.3905 51.8713 46.3835 51.9066 46.37 51.9395C46.3564 51.9724 46.3364 52.0024 46.3113 52.0276C46.2861 52.0528 46.2563 52.0728 46.2234 52.0864C46.1905 52.1001 46.1552 52.1071 46.1196 52.1071Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5366 54.0423H20.2346C19.5978 54.0423 18.9698 54.0172 18.3506 53.967C18.4007 54.0149 18.4672 54.0419 18.5366 54.0423Z",
    fill: "#44352A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1199 42.7849H37.6871C36.3846 49.1589 29.0666 54.0423 20.2349 54.0423H46.121C46.1566 54.0423 46.1919 54.0352 46.2248 54.0216C46.2577 54.008 46.2876 53.988 46.3127 53.9627C46.3379 53.9375 46.3578 53.9076 46.3714 53.8747C46.385 53.8418 46.3919 53.8065 46.3919 53.7709V43.0562C46.3919 43.0205 46.3849 42.9852 46.3713 42.9522C46.3576 42.9192 46.3376 42.8892 46.3123 42.864C46.2871 42.8388 46.257 42.8188 46.224 42.8052C46.191 42.7916 46.1556 42.7847 46.1199 42.7849Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1196 42.7849H18.5365C18.4646 42.7849 18.3955 42.8134 18.3446 42.8643C18.2937 42.9152 18.2651 42.9843 18.2651 43.0562V43.408C18.2651 43.336 18.2937 43.267 18.3446 43.2161C18.3955 43.1652 18.4646 43.1366 18.5365 43.1366H46.1196C46.1552 43.1366 46.1905 43.1436 46.2234 43.1573C46.2563 43.1709 46.2861 43.1909 46.3113 43.2161C46.3364 43.2413 46.3564 43.2712 46.37 43.3042C46.3835 43.3371 46.3905 43.3724 46.3904 43.408V43.0562C46.3905 43.0206 46.3835 42.9854 46.37 42.9524C46.3564 42.9195 46.3364 42.8896 46.3113 42.8644C46.2861 42.8392 46.2563 42.8192 46.2234 42.8055C46.1905 42.7919 46.1552 42.7849 46.1196 42.7849Z",
    fill: "#44352A"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2124 52.5908H16.4427C16.254 52.5908 16.1011 52.7438 16.1011 52.9324V54.6237C16.1011 54.8124 16.254 54.9654 16.4427 54.9654H48.2124C48.4011 54.9654 48.554 54.8124 48.554 54.6237V52.9324C48.554 52.7438 48.4011 52.5908 48.2124 52.5908Z",
    fill: "#44352A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2124 54.6585H16.4427C16.3521 54.6585 16.2652 54.6225 16.2011 54.5585C16.1371 54.4944 16.1011 54.4075 16.1011 54.3169V54.6237C16.1011 54.7143 16.1371 54.8012 16.2011 54.8652C16.2652 54.9293 16.3521 54.9653 16.4427 54.9653H48.2124C48.303 54.9653 48.3899 54.9293 48.4539 54.8652C48.518 54.8012 48.554 54.7143 48.554 54.6237V54.3169C48.554 54.4075 48.518 54.4944 48.4539 54.5585C48.3899 54.6225 48.303 54.6585 48.2124 54.6585Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2124 52.5908H16.4427C16.3521 52.5908 16.2652 52.6268 16.2011 52.6909C16.1371 52.755 16.1011 52.8418 16.1011 52.9325V53.2488C16.1011 53.1582 16.1371 53.0713 16.2011 53.0072C16.2652 52.9432 16.3521 52.9072 16.4427 52.9072H48.2124C48.303 52.9072 48.3899 52.9432 48.4539 53.0072C48.518 53.0713 48.554 53.1582 48.554 53.2488V52.9325C48.554 52.8418 48.518 52.755 48.4539 52.6909C48.3899 52.6268 48.303 52.5908 48.2124 52.5908Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2126 52.5908H39.1538C39.2444 52.5908 39.3313 52.6268 39.3954 52.6909C39.4594 52.755 39.4954 52.8418 39.4954 52.9325V54.6237C39.4954 54.7143 39.4594 54.8012 39.3954 54.8653C39.3313 54.9294 39.2444 54.9654 39.1538 54.9654H48.2126C48.3032 54.9654 48.3901 54.9294 48.4541 54.8653C48.5182 54.8012 48.5542 54.7143 48.5542 54.6237V52.9325C48.5542 52.8418 48.5182 52.755 48.4541 52.6909C48.3901 52.6268 48.3032 52.5908 48.2126 52.5908Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6793 54.6237V52.9325C23.6793 52.8418 23.7153 52.755 23.7794 52.6909C23.8434 52.6268 23.9303 52.5908 24.0209 52.5908H19.0926C19.002 52.5908 18.9151 52.6268 18.851 52.6909C18.787 52.755 18.751 52.8418 18.751 52.9325V54.6237C18.751 54.7143 18.787 54.8012 18.851 54.8653C18.9151 54.9294 19.002 54.9654 19.0926 54.9654H24.0209C23.9303 54.9654 23.8434 54.9294 23.7794 54.8653C23.7153 54.8012 23.6793 54.7143 23.6793 54.6237Z",
    fill: "#44352A"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8475 44.4451H20.7612V51.2468H43.8475V44.4451Z",
    fill: "#EFCA6F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8475 51.1018H20.7612V51.2468H43.8475V51.1018Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8475 44.4451H20.7612V44.5901H43.8475V44.4451Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.269 42.7848H41.3865C41.3865 42.6078 41.3703 42.4312 41.3382 42.2572H23.3179C23.2857 42.4312 23.2693 42.6078 23.269 42.7848Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2005 44.4451C36.152 47.1759 33.9719 49.5454 31.0669 51.2468H43.8476V44.4451H37.2005Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6692 45.6847C21.8875 45.6847 22.0644 45.5077 22.0644 45.2894C22.0644 45.0711 21.8875 44.8942 21.6692 44.8942C21.4509 44.8942 21.2739 45.0711 21.2739 45.2894C21.2739 45.5077 21.4509 45.6847 21.6692 45.6847Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3627 45.291C43.3621 45.2134 43.3386 45.1376 43.2951 45.0734C43.2516 45.0091 43.19 44.9592 43.1181 44.9299C43.0463 44.9006 42.9673 44.8932 42.8913 44.9087C42.8152 44.9241 42.7455 44.9618 42.6908 45.0169C42.6361 45.0719 42.5989 45.142 42.584 45.2181C42.5691 45.2943 42.577 45.3732 42.6068 45.4448C42.6367 45.5165 42.687 45.5777 42.7516 45.6207C42.8162 45.6638 42.8921 45.6868 42.9697 45.6868C43.0215 45.6868 43.0728 45.6765 43.1207 45.6566C43.1686 45.6367 43.212 45.6075 43.2486 45.5707C43.2851 45.5339 43.314 45.4902 43.3336 45.4422C43.3532 45.3942 43.3631 45.3428 43.3627 45.291Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9675 50.7916C43.1858 50.7916 43.3628 50.6146 43.3628 50.3963C43.3628 50.178 43.1858 50.001 42.9675 50.001C42.7492 50.001 42.5723 50.178 42.5723 50.3963C42.5723 50.6146 42.7492 50.7916 42.9675 50.7916Z",
    fill: "#EFCA6F"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6399 45.6424C21.8582 45.6424 22.0351 45.4655 22.0351 45.2472C22.0351 45.0289 21.8582 44.8519 21.6399 44.8519C21.4216 44.8519 21.2446 45.0289 21.2446 45.2472C21.2446 45.4655 21.4216 45.6424 21.6399 45.6424Z",
    fill: "#44352A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6692 50.7871C21.8875 50.7871 22.0644 50.6101 22.0644 50.3918C22.0644 50.1735 21.8875 49.9966 21.6692 49.9966C21.4509 49.9966 21.2739 50.1735 21.2739 50.3918C21.2739 50.6101 21.4509 50.7871 21.6692 50.7871Z",
    fill: "#EFCA6F"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6399 50.7435C21.8582 50.7435 22.0351 50.5665 22.0351 50.3482C22.0351 50.1299 21.8582 49.9529 21.6399 49.9529C21.4216 49.9529 21.2446 50.1299 21.2446 50.3482C21.2446 50.5665 21.4216 50.7435 21.6399 50.7435Z",
    fill: "#44352A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9675 45.6424C43.1858 45.6424 43.3628 45.4655 43.3628 45.2472C43.3628 45.0289 43.1858 44.8519 42.9675 44.8519C42.7492 44.8519 42.5723 45.0289 42.5723 45.2472C42.5723 45.4655 42.7492 45.6424 42.9675 45.6424Z",
    fill: "#44352A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9675 50.7435C43.1858 50.7435 43.3628 50.5665 43.3628 50.3482C43.3628 50.1299 43.1858 49.9529 42.9675 49.9529C42.7492 49.9529 42.5723 50.1299 42.5723 50.3482C42.5723 50.5665 42.7492 50.7435 42.9675 50.7435Z",
    fill: "#44352A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableLogo);
export default __webpack_public_path__ + "static/media/tableLogo.6ef24e3f1ca7a3ed794c78f83230691c.svg";
export { ForwardRef as ReactComponent };